import { render, staticRenderFns } from "./ProductsComponent.vue?vue&type=template&id=5896b89a&scoped=true&"
import script from "./ProductsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5896b89a",
  null
  
)

export default component.exports